import { atom } from 'recoil';

import dayjs from 'dayjs';

/** 미분류 상조 ID (shop에 등록되지 않은 bugoBrand) */
export const SELLER_BRAND_ETC_ID = '__etc__';

/** bugoBrand 항목 (id + 표시용 label) */
export interface SellerBrandOption {
  id: string;
  label: string; // nickName
}

/** 전체 브랜드 목록 (초기화 시 shop.bugoBrands에서 생성) */
export const sellerBrandOptionsAtom = atom<SellerBrandOption[]>({
  key: 'sellerBrandOptionsAtom',
  default: [],
});

/** 현재 선택된 bugoBrand ID Set */
export const sellerSelectedBrandIdsAtom = atom<Set<string>>({
  key: 'sellerSelectedBrandIdsAtom',
  default: new Set(),
});

/**
 * selectedBrandIds + brandOptions → API 파라미터 변환
 *
 * 케이스 1: 기타 미포함 → { bugoBrandIds: [...선택된 ID] }
 * 케이스 2-1: 기타 포함 + 전체 → undefined (파라미터 없음)
 * 케이스 2-2: 기타 포함 + 부분 → { excludeBugoBrandIds: [...해제된 ID] }
 */
export function buildBrandFilterParams(
  selectedBrandIds: Set<string>,
  brandOptions: SellerBrandOption[],
): { bugoBrandIds?: string[]; excludeBugoBrandIds?: string[] } | undefined {
  const knownOptions = brandOptions.filter((o) => o.id !== SELLER_BRAND_ETC_ID);
  const knownIds = knownOptions.map((o) => o.id);
  const selectedReal = knownIds.filter((id) => selectedBrandIds.has(id));
  const isEtcSelected = selectedBrandIds.has(SELLER_BRAND_ETC_ID);

  if (isEtcSelected && selectedReal.length === knownIds.length) {
    // 케이스 2-1: 전체 선택 → 파라미터 없음
    return undefined;
  }

  if (isEtcSelected) {
    // 케이스 2-2: 기타 포함 + 일부 해제 → 해제된 ID를 exclude로
    const uncheckedIds = knownIds.filter((id) => !selectedBrandIds.has(id));
    return { excludeBugoBrandIds: uncheckedIds };
  }

  // 케이스 1: 기타 미포함 → 선택된 ID만 include로
  return { bugoBrandIds: selectedReal };
}

/** admin 대리 조회 시 seller userId (store-seller 본인이면 undefined) */
export const sellerAccountUserIdAtom = atom<string | undefined>({
  key: 'sellerAccountUserIdAtom',
  default: undefined,
});

export const sellerAccountSelectYearAtom = atom<dayjs.Dayjs | null>({
  key: 'sellerAccountSelectYearAtom',
  default: dayjs(),
});

export const sellerAccountShowAtom = atom<boolean>({
  key: 'sellerAccountShowAtom',
  default: false,
});
